import { Routes, RouterModule } from "@angular/router";

import { AuthguardService } from "../master/services";
import { TestPageComponent } from "./components/test-page.component";

export const TestPageRoutes: Routes = [
	{
		path: "TestDashboard",
		data: { title: "Test Dashboard" },
		component: TestPageComponent,
		canActivate: [AuthguardService],
	},
];
